import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { Subscription } from 'rxjs';
import { EmployeeAttribute } from '../../entities/employee-attribute';
import { StaffDetail } from '../../entities/staff-detail';
import { StaffCountService } from '../../services/staff-count.service';


@Component({
    selector: 'app-staff-count-details',
    templateUrl: './staff-count-details.component.html',
    styleUrls: ['./staff-count-details.component.scss'],
    standalone: false
})
export class StaffCountDetailsComponent implements OnInit, OnDestroy {

  @Input() selectedAttribute: number;
  @Input() iteration: number;
  @Output() refresh: EventEmitter<{ companyId: string, year: string, month: string, attribute: string, tipo: string }> = new EventEmitter();
  staffDetail: StaffDetail;
  private subscriptions: Subscription;
  private subscriptionsAttribute: Subscription;
  staffDetailForm: UntypedFormGroup;


  constructor(public _staffCountService: StaffCountService, private formBuilder: UntypedFormBuilder) {
    this.subscriptions = this._staffCountService.detailsSelected.subscribe((arg) => {
      if (arg) {
        this.getCompanyStaffData(arg.companyId, arg.year, arg.month, arg.tipo);
      }
    });

    this.subscriptionsAttribute = this._staffCountService.detailsAttributeSelected.subscribe((arg) => {
      if (arg) {
        this.getCompanyAttributeStaffData(arg.companyId, arg.year, arg.month, arg.attribute, arg.tipo);
      }
    });

  }

  ngOnInit(): void {
    this.staffDetail = new StaffDetail();
    // need for further development
    // this._staffCountService.checkoutRoomsCalled.subscribe(_checkinId => {
    //   if (_checkinId > 0) {
    //   }
    // });
    this.initFormBuilder();
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
    this.subscriptionsAttribute.unsubscribe();
  }


  getCompanyStaffData(companyId: string, year: string, month: string, tipo: string) {
    this._staffCountService.getStaffCount(companyId, year, month, tipo)
      .subscribe(res => {
        this.staffDetail = res.result;
        this._staffCountService.showDetailPanel = (this.staffDetail != null) ? true : false;
        this.setFormValue(this.staffDetail, companyId, year, month, "null", tipo);
      }, err => {
        console.error(err);
      });
  }

  getCompanyAttributeStaffData(companyId: string, year: string, month: string, attribute: string, tipo: string) {
    this._staffCountService.getStaffAttributeCount(companyId, year, month, attribute, tipo)
      .subscribe(res => {
        this.staffDetail = res.result;
        this._staffCountService.showDetailPanel = (this.staffDetail != null) ? true : false;
        this.setFormValue(this.staffDetail, companyId, year, month, attribute, tipo);
      }, err => {
        console.error(err);
      });
  }

  setFormValue(staffDetail: StaffDetail, companyId: string, year: string, month: string, attribute: string, tipo: string) {
    this.staffDetailForm = this.formBuilder.group(
      {
        companyId: companyId,
        attribute: attribute,
        tipo: tipo,
        year: year,
        month: month,
        plantilla: staffDetail?.plantilla,
        hombre: staffDetail?.hombre,
        mujer: staffDetail?.mujer,
        edad18: staffDetail?.edad18,
        edad31: staffDetail?.edad31,
        edad41: staffDetail?.edad41,
        edad51: staffDetail?.edad51,
        edad61: staffDetail?.edad61
      }
    );
  }

  updateDetail() {
    this._staffCountService.updateStaffDetail(this.staffDetailForm.value).subscribe((res) => {
      if (res.code == 0) {
        this.refresh.emit({
          companyId: this.staffDetailForm.value.companyId,
          year: this.staffDetailForm.value.year,
          month: this.staffDetailForm.value.month,
          attribute: this.staffDetailForm.value.attribute,
          tipo: this.staffDetailForm.value.tipo
        });
      }
    });
  }

  public initFormBuilder(): void {
    this.staffDetailForm = this.formBuilder.group(
      {
        companyId: [0],
        attribute: [0],
        tipo: [0],
        year: [''],
        month: [''],
        plantilla: [0],
        hombre: [''],
        mujer: [''],
        edad18: [''],
        edad31: [''],
        edad41: [''],
        edad51: [''],
        edad61: ['']
      }
    );
  }


}

